/**
 * @prettier
 */

import StageComplete from "../../../components/Messages/StageComplete";
import Header from "../../../components/Header";
import Navigator from "../../../components/Navigator";

const DocumentUploadCompletedState = ({
    onContinue,
    navigationAction,
    navigationProps,
}) => (
    <>
        <Header />
        <StageComplete
            continue={onContinue}
            message="idpal_document_captured"
        />
        <Navigator
            page={"document_review"}
            action={navigationAction}
            propsToPass={navigationProps}
        />
    </>
);

export default DocumentUploadCompletedState;
